import {
  UPDATERAIDEVENTANDSIGNUPS} from '../modules/raidHelper';
import {
  RAIDEVENT_HANDLEERROR,
  RAIDEVENT_SETLOADING } from '../modules/raidHelper';

export {
  doRaidHelperAPICall,
}

function getNameFromSignup( signupname ) {
  var tokens = signupname.split( '/' );
  tokens = tokens[0].split( '(' );
  tokens = tokens[0].split( '-' );
  tokens = tokens[0].split( '[' );
  var result = tokens[0].charAt(0).toUpperCase()
               + tokens[0].slice(1);
  return result;
}

function getDateFromRaidHelper( datestring ) {
  var tokens = datestring.split( '-' );
  return new Date( parseInt( tokens[2] ),
                   parseInt( tokens[1] ) - 1, // Month is 0-indexed
                   parseInt( tokens[0] ) );
}

function getDayOfWeekFromDate( date ) {
  switch( date.getDay() ) {
    case 0: return "Sunday";
    case 1: return "Monday";
    case 2: return "Tuesday";
    case 3: return "Wednesday";
    case 4: return "Thursday";
    case 5: return "Friday";
    case 6: return "Saturday";
  }
}

function handleRaidHelperAPIResponse( dispatch, response, guild, lockout, raidevent, specs ) {
  console.log( 'response', response )

  // Error-handling
  let errormsg = null

  if( response.status != 200 ) {
    errormsg = 'Response status ' + response.status + ': ' + response.statusText
  }

  if( !response.data ) {
    errormsg = 'No data field in response (malformed response)'
  }

  if( response.data.status && response.data.status == 'failed' ) {
    errormsg = response.data.reason
  }

  if( response.data.raidid != raidevent['.key'] ) {
    errormsg = 'Received data is for another event: ' + response.data.raidid
  }

  if( errormsg ) {
    dispatch( RAIDEVENT_HANDLEERROR, { lockout: lockout, raidevent: raidevent, errormsg: errormsg })
    return
  }

  // Actual data processing

  // Get some data about the event
  let event = response.data;
  let date = getDateFromRaidHelper( event.date )
  let color = event.advanced.color || null
  let eventData = {
    date: new Date( date ).getTime(),
    day: getDayOfWeekFromDate( date ),
    name: event.title,
    time: event.time,
    color: ( color && color != "0" ? color : raidevent.color ),
    fullcolor: event.color, // TODO: some new RGB-field
    template: event.template, // Template used to create event
    eventtime: event.unixtime, // TODO: We can use this rather than parsing 'date' and 'time'
    closingtime: event.closingtime, // TODO: we can use this to determine whether the event is closed
    duration: event.advanced.duration || null,
    serverid: event.serverid,
    servername: event.servername,
    channelid: event.channelid,
    channelname: event.channelName,
  }

  // Loop through all entries in the data
  var newsignups = []
  for( var signup of response.data.signups ) {

    let spec = ''
    const obj = specs.find(s => s.raidhelperspec == signup.spec
      && (s.raidhelperrole == signup.role || ['Tentative', 'Late', 'Bench'].includes(signup.role))
      && (!s.raidhelperclass || s.raidhelperclass == signup.class));
    if (obj) spec = obj.name;
  
    var newsignup = {
      playerid: signup.userid,
      eventid: raidevent['.key'],
      spec: spec,
      name: getNameFromSignup( signup.name ),
      isprimary: signup.status == 'primary',
      timestamp: signup.signuptime * 1000,
      tentative: signup.class == 'Tentative',
      late: signup.class == 'Late',
      bench: signup.class == 'Bench',
      absent: signup.class == 'Absence' || signup.spec == 'Absence',
      position: signup.position,
      valid: true, // Just loaded, so valid
    }

    // RaidHelper no longer supplies signup-IDs, so we're making one
    let signupid = event.raidid + '_' + signup.userid + '_' + signup.signuptime + '_' + spec
    let signuphash = cyrb53( signupid )
    // console.log( 'signuphash', signupid, signuphash )

    Object.defineProperty( newsignup, '.key', { value: signuphash, enumerable: false } )

    newsignups.push( newsignup )
  }
  
  dispatch( UPDATERAIDEVENTANDSIGNUPS, { guild: guild,
                                         lockout: lockout,
                                         raidevent: raidevent,
                                         eventData: eventData,
                                         newsignups: newsignups } )
}

function cyrb53(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1>>>16), 2246822507) ^ Math.imul(h2 ^ (h2>>>13), 3266489909);
  h2 = Math.imul(h2 ^ (h2>>>16), 2246822507) ^ Math.imul(h1 ^ (h1>>>13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1>>>0);
}

async function doRaidHelperAPICall( commit, dispatch, guild, lockout, raidevent, connection, specs ) {

  var axios = require('axios');

  commit( RAIDEVENT_SETLOADING, { raidevent: raidevent, isloading: true } );

  const url = connection.url.replaceAll( '{eventid}', raidevent['.key'] );
  // const auth = connection.bearer.replaceAll( '{token}', token.bearer );
  // const args = { headers: { "Authorization": auth } };
  const args = {};

  try {
    const response = await axios.get( url, args )

    handleRaidHelperAPIResponse( dispatch, response, guild, lockout, raidevent, specs );

  } catch ( error ) {
    console.error( error );
    dispatch( RAIDEVENT_HANDLEERROR, { lockout: lockout, raidevent: raidevent, errormsg: error } )
  }

  commit( RAIDEVENT_SETLOADING, { raidevent: raidevent, isloading: false } );
}
